import React, { useState } from 'react';

const UserFilter = ({ usersList, setFilter, setListSearch }) => {
  const [applied, setApplied] = useState(false);
  const [roleID, setRoleID] = useState('');

  return (
    <div>
      <div
        className='modal fade'
        id='filterUser'
        aria-labelledby='filterUserLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content  admin-list'>
            <div className='modal-header'>
              <h5 className='modal-title' id='filterUserLabel'>
                Filter User
              </h5>
              <button
                type='button'
                className='btn-close btn-close-white'
                data-bs-dismiss='modal'
                aria-label='Close'
              ></button>
            </div>

            <div className='modal-body'>
              <div className='mb-3'>
                <div className='txt-primary'>Role</div>
                <select
                  className='form-select admin-list'
                  aria-label='Default select example'
                  id='RoleID'
                  value={roleID}
                  onChange={(e) => setRoleID(e.target.value)}
                >
                  <option value={''}>------------------</option>
                  <option value={1}>{'Admin'}</option>
                  <option value={2}>{'Operator'}</option>
                  <option value={3}>{'End User'}</option>
                </select>
              </div>
            </div>

            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-bs-dismiss='modal'
              >
                Cancel
              </button>
              <button
                type='button'
                className='btn admin-list-btn-secondary text-white'
                onClick={() => {
                  setFilter({ roleID });
                  setApplied(true);
                  setRoleID('');
                }}
                data-bs-dismiss='modal'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {!applied ? (
        <div
          className='btn button-parent admin-list-button d-flex align-items-center admin-list-btn-secondary text-white'
          data-bs-toggle='modal'
          data-bs-target='#filterUser'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            fill='#ffffff'
            class='bi bi-funnel-fill'
            viewBox='0 0 16 16'
          >
            <path d='M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z' />
          </svg>
        </div>
      ) : (
        <div
          className='btn button-parent btn-danger d-flex align-items-center'
          onClick={() => {
            setListSearch(usersList);
            setApplied(false);
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            fill='#ffffff'
            class='bi bi-x-lg'
            viewBox='0 0 16 16'
          >
            <path d='M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z' />
          </svg>
        </div>
      )}
    </div>
  );
};

export default UserFilter;
